import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListingDataSource, ListingPayload } from '@portal/shared/types/listing.types';
import { TimezoneService } from 'src/app/services/utility/timezone.service';
import { FieldOperationsService } from '../ui/field-operations.service';
import { FieldOperationFilterName, type FieldOperationsList } from '../ui/field-operations.types';

@Injectable()
export class FieldOperationsListingDataSourceService implements ListingDataSource<FieldOperationsList> {
  private readonly fieldOperationsService = inject(FieldOperationsService);
  private readonly timezoneService = inject(TimezoneService);

  total = 0;

  getAll(tableState: ListingPayload): Observable<FieldOperationsList> {
    return this.fieldOperationsService.readList({
      ...tableState,
      filters: (tableState.filters ?? []).map(f => ({
        ...f,
        filteredValues:
          f.filterType === FieldOperationFilterName.InstallationDateTimeUtc && f.filteredValues.length === 2
            ? this.timezoneService.getShiftedDatepickerRangeStringified({
                start: new Date(f.filteredValues[0]),
                end: new Date(f.filteredValues[1])
              })
            : f.filteredValues
      }))
    });
  }
}
